import { Component, OnInit } from '@angular/core';
import {DialogDefinitionEditorBase} from '@shared/components/platform-tool/platform-tool-dialog-definition/models/dialog-defnition-models';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {Subject} from 'rxjs';
import {Store} from '@ngrx/store';
import {ParticleState} from '@shared/store/reducers/particle.reduer';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {CellValue} from '@shared/models/paged-response-model';
import {Configuration} from '@shared/models/configuration';
import {BasketProvider} from '@shared/models/basket-provider';

@Component({
    standalone: false,
    selector: 'app-dialog-field-entity-selector-editor',
  templateUrl: './dialog-field-entity-selector-editor.component.html',
  styleUrls: ['./dialog-field-entity-selector-editor.component.scss']
})
export class DialogFieldEntitySelectorEditorComponent extends DialogDefinitionEditorBase implements OnInit {

  filterId: string;
  invalidateSubject: InvalidateSubject;
  filterTemplateId: string;
  endpointName: string;
  displayTextConfig: string;
  sourceType = '';
  ngUnsubscribe$ = new Subject();
  itemType: string;

  constructor(protected particleStore: Store<ParticleState>, protected fuseSplashScreenService: FuseSplashScreenService) {
    super();
    this.invalidateSubject = new InvalidateSubject();
  }


  ngOnInit() {
    super.ngOnInit();
    if (!this.dialogField.value) {
      this.filterId = `${this.dialogField.fieldValues['ItemId']}-${this.dialogField.key}`;
      this.dialogField.value = this.filterId;
    }
    const filterValue = this.dialogField.value;
    if(filterValue !== null && typeof(filterValue) === 'object'){
      if(filterValue.item2 === ''){
        this.filterId = `${this.dialogField.fieldValues['ItemId']}-${this.dialogField.key}`;
      }else{
        this.filterId = filterValue.item2;
      }
    }else{
      this.filterId = filterValue;
    }
    const configKey = this.dialogField.fieldValues.ConfigKey;

    if (configKey) {
      const config = Configuration.getSmartGridConfig(configKey);
      if (config.DisplayTextConfig) {
        this.displayTextConfig = config.DisplayTextConfig;
      }
      if (config.SourceType) {
        this.sourceType = config.SourceType;
      }
      this.filterTemplateId = config.FilterTemplateId;
      this.endpointName = config.RootUrlKey;
      const leftConfig = Configuration.getSmartGridConfig(config.LeftConfig);
      leftConfig.ItemsUrlIndex = config.ItemsUrlIndex;
      leftConfig.Parameters['SOURCE_TYPE'] = this.sourceType;
      leftConfig.Parameters['DATA_ITEM_ID'] = this.dialogField.fieldValues['ItemId'];

      const rightConfig = Configuration.getSmartGridConfig(config.RightConfig);
      rightConfig.ItemsUrlIndex = config.ItemsUrlIndex;
      rightConfig.Parameters['SOURCE_TYPE'] = this.sourceType;
      rightConfig.Parameters['DATA_ITEM_ID'] = this.dialogField.fieldValues['ItemId'];
    }
    this.itemType = this.sourceType;
    if(this.dialogField.fieldValues['Type']){
      const type = this.dialogField.fieldValues['Type'];
      const itemBasket = BasketProvider.getBasketBySourceType(type);
      if(itemBasket){
        for(let key in itemBasket.sourceTypes){
          if(key === this.sourceType){
            this.itemType = itemBasket.sourceTypes[key];
          }
        }
      }
    }
  }

  validationChangeEmitter($event) {

  }

}
